import Api from "./Api";
import Csrf from "./Csrf";

export default {
    
  async index() {
    await Csrf.getCookie();

    return Api.get("/emails");
  },
    
  async update(id,data) {
    await Csrf.getCookie();

    return Api.patch("/emails/"+id,data);
  },
	
};